import axiosInstance from "../../../interceptor/intercetptor-inctence";

/** Create sample collection records for a test order (bulk) */
export const addSampleCollection = (payload) => {
    return axiosInstance.post(`api/test-order-sample/add`, payload);
};

/** Paginated lab sample collection worklist */
export const getSampleCollectionList = (payload) => {
    return axiosInstance.post(`api/test-order-sample/list`, payload);
};

/** View sample collection by ID */
export const viewSampleCollection = (id) => {
    return axiosInstance.post(`api/test-order-sample/view/${id}`, {});
};

/** View sample collection by barcode (scanner / lookup) */
export const viewSampleByBarcode = (barcodeId) => {
    return axiosInstance.post(
        `api/test-order-sample/view-by-barcode/${encodeURIComponent(barcodeId)}`,
        {}
    );
};

/** Patient sample collections */
export const getPatientSampleCollections = (patientId, payload = {}) => {
    return axiosInstance.post(`api/test-order-sample/patient/${patientId}`, payload);
};

/** Sample collections for a test order (order detail page) */
export const getOrderSampleCollections = (testOrderId, payload = {}) => {
    return axiosInstance.post(`api/test-order-sample/order/${testOrderId}`, payload);
};

/**
 * Partial update: status, notes, and/or assignedEquipment.
 * Prefer JSON so assignedEquipment can be sent as a string[].
 */
export const updateSampleCollection = (id, payload) => {
    return axiosInstance.post(`api/test-order-sample/update/${id}`, payload);
};

/** Dedicated status update; optional collectionTime */
export const updateSampleCollectionStatus = (id, payload) => {
    return axiosInstance.post(`api/test-order-sample/update-status/${id}`, payload);
};

/** Collect a pending sample */
export const collectSample = (id, payload = {}) => {
    return axiosInstance.post(`api/test-order-sample/collect/${id}`, payload);
};

/** Recollect: sample id is the path param; body is the replacement sample JSON. */
export const recollectSample = (id, payload = {}) => {
    return axiosInstance.post(`api/test-order-sample/recollect/${id}`, payload);
};

export const SAMPLE_COLLECTION_STATUSES = [
    "Pending",
    "Collected",
    "Completed",
    "Rejected",
    "Cancelled",
    "Re-Collected"
];

/** Statuses that can be chosen from the update dropdown. Collected and Re-Collected stay filter-only. */
export const SAMPLE_COLLECTION_UPDATE_STATUSES = SAMPLE_COLLECTION_STATUSES.filter(
    (status) => status !== "Collected" && status !== "Re-Collected"
);

/** Pending samples can be collected */
export const canCollectStatus = (status) => {
    return String(status || "") === "Pending";
};

/** Rejected / Cancelled samples can be recollected */
export const canRecollectStatus = (status) => {
    const value = String(status || "");
    return value === "Rejected" || value === "Cancelled";
};
